import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { ScreenService } from '../services/screen.service';

@Injectable({
  providedIn: 'root'
})
export class ScreenGuard {
  private screenService = inject(ScreenService)
  private router = inject(Router)

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    this.screenService.isScreenDesktop();
    if(this.screenService.isDesktop) {
      this.router.navigate(['/inicio'])
      return false
    } else return true
  }
}
